const noticeRoutes = [
  {
    path: '/notice/:noticeId/notice-detail',
    name: 'NoticeDetail',
    component: () => import('@/views/notice-detail'),
    meta: {
      layout: 'DefaultLayout',
      title: '公告详情'
    }
  }
]

export default noticeRoutes
